import checkmark from "assets/icons/checkmark.svg"
import { Icon } from "materia"
import { modifiers } from "ui-tools"

import s from "./styles.module.scss"

type JourneyThumbnailProps = {
  isLocked?: boolean
  isCertified?: boolean
  imageUrl?: string | null
}
export const JourneyThumbnail = ({
  isLocked = false,
  isCertified = false,
  imageUrl,
}: JourneyThumbnailProps) => {
  // A journey can be both locked and completed because reasons.
  // In this case the "locked" state should take precedence over the
  // "completed", because it still blocks the journeys depending on it.
  // If it's neither, show Journey's thumbnail image.
  const getThumbnailImage = () => {
    if (isLocked) return <Icon icon="Lock" />

    if (isCertified) return <img src={checkmark} alt="" />

    return (
      <div
        className={s.journeyThumbnail__image}
        style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}}
      />
    )
  }

  return (
    <div
      className={modifiers(s, "journeyThumbnail", {
        certified: isCertified,
        locked: isLocked,
      })}
    >
      {getThumbnailImage()}
    </div>
  )
}
